/**
 * Opens an empty tab synchronously in the click handler, before the download-ticket request is
 * sent — this keeps the user-activation context the browser requires to allow `window.open`, since
 * the actual destination URL is only known after an `await`. `opener` is cleared immediately
 * (reverse-tabnabbing protection) before the later cross-origin navigation. Returns `null` when
 * the browser's popup blocker already rejects the empty tab; the caller's `onError`/`onSuccess`
 * handlers (see {@link navigiereTab}) treat that the same as "tab closed" — no error is thrown here.
 */
export function oeffneVorbereitetenTab(): Window | null {
  const tab = window.open('about:blank', '_blank');
  if (tab) tab.opener = null;
  return tab;
}

/**
 * Navigates the tab {@link oeffneVorbereitetenTab} prepared to the one-shot SAS URL (ADR-SW-025) —
 * the URL is never logged or stored, only handed to `location.href` for this one navigation. Falls
 * back to a fresh `window.open` call if the prepared tab was `null` or has since been closed (e.g. a
 * popup blocker that let the empty tab through but not a later navigation, or a user who closed it
 * while the request was in flight) — not an error state, but it loses the pre-flight popup-blocker
 * bypass this function exists for.
 */
export function navigiereTab(tab: Window | null, url: string): void {
  if (tab && !tab.closed) {
    tab.location.href = url;
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
